export default {"src":"/_next/static/media/bungalow-icon-selected.d2cb371e.svg","height":75,"width":122,"blurWidth":0,"blurHeight":0};